module.exports = __webpack_public_path__ + "img/zs_3@2x.3d01fe2b.png";